import { render, staticRenderFns } from "./edit-dealer.vue?vue&type=template&id=7006ae29&scoped=true&"
import script from "./edit-dealer.vue?vue&type=script&lang=js&"
export * from "./edit-dealer.vue?vue&type=script&lang=js&"
import style0 from "./edit-dealer.vue?vue&type=style&index=0&id=7006ae29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7006ae29",
  null
  
)

export default component.exports